import type { EnvioDiretoDto, PedirEnvioEntrada } from '@nexital/shared';

/** SHA-256 do arquivo em base64, como o S3 confere no cabeçalho x-amz-checksum-sha256. */
export async function sha256Base64(arquivo: Blob) {
  const hash = new Uint8Array(await crypto.subtle.digest('SHA-256', await arquivo.arrayBuffer()));
  let binario = '';
  for (const byte of hash) binario += String.fromCharCode(byte);
  return btoa(binario);
}

/**
 * Envio direto ao S3 (RQ-ARQ-003): pede a URL assinada (com tipo, tamanho e hash), faz o PUT do arquivo com
 * exatamente os cabeçalhos assinados e devolve a referência para o servidor confirmar.
 */
export async function enviarDiretoAoS3(arquivo: File, pedir: (entrada: PedirEnvioEntrada) => Promise<EnvioDiretoDto>) {
  const entrada = { nome: arquivo.name, mime: arquivo.type || 'application/octet-stream', tamanhoBytes: arquivo.size, sha256: await sha256Base64(arquivo) };
  const envio = await pedir(entrada);
  const resposta = await fetch(envio.url, { method: 'PUT', headers: envio.cabecalhos, body: arquivo });
  if (!resposta.ok) throw new Error('O armazenamento recusou o arquivo. Tente de novo.');
  return envio.referencia;
}
